import React from "react";
import _ from "lodash";
import { assetsPath } from "../../utils";

const baseAssetUrl = assetsPath("phuket-skypark");
const baseAssetVideoUrl = `${baseAssetUrl}/videos`;

const heroShotImg1 = `${baseAssetUrl}/images/gallery/hero-shot/01.jpg`;
const heroShotImg2 = `${baseAssetUrl}/images/gallery/hero-shot/02.jpg`;
const heroShotImg3 = `${baseAssetUrl}/images/gallery/hero-shot/03.jpg`;
const heroShotImg4 = `${baseAssetUrl}/images/gallery/hero-shot/04.jpg`;
const heroShotImg5 = `${baseAssetUrl}/images/gallery/hero-shot/05.jpg`;
const heroShotImg6 = `${baseAssetUrl}/images/gallery/hero-shot/06.jpg`;
const heroShotImg7 = `${baseAssetUrl}/images/gallery/hero-shot/07.jpg`;
const heroShotImg8 = `${baseAssetUrl}/images/gallery/hero-shot/08.jpg`;
const heroShotImg9 = `${baseAssetUrl}/images/gallery/hero-shot/09.jpg`;
// const heroShotImg10 = `${baseAssetUrl}/images/gallery/hero-shot/10.jpg`;

const residencesAerial1 = `${baseAssetUrl}/images/gallery/images/residences-aerial/01.jpg`;
const residencesAerial2 = `${baseAssetUrl}/images/gallery/images/residences-aerial/02.jpg`;
const residencesAerial3 = `${baseAssetUrl}/images/gallery/images/residences-aerial/03.jpg`;
const residencesAerial4 = `${baseAssetUrl}/images/gallery/images/residences-aerial/04.jpg`;

const residencesExterior1 = `${baseAssetUrl}/images/gallery/images/residences-exterior/01.jpg`;
const residencesExterior2 = `${baseAssetUrl}/images/gallery/images/residences-exterior/02.jpg`;
const residencesExterior3 = `${baseAssetUrl}/images/gallery/images/residences-exterior/03.jpg`;
const residencesExterior4 = `${baseAssetUrl}/images/gallery/images/residences-exterior/04.jpg`;

const residencesInterior1 = `${baseAssetUrl}/images/gallery/images/residences-interior/01.jpg`;
const residencesInterior2 = `${baseAssetUrl}/images/gallery/images/residences-interior/02.jpg`;
const residencesInterior3 = `${baseAssetUrl}/images/gallery/images/residences-interior/03.jpg`;
const residencesInterior4 = `${baseAssetUrl}/images/gallery/images/residences-interior/04.jpg`;
const residencesInterior5 = `${baseAssetUrl}/images/gallery/images/residences-interior/05.jpg`;
const residencesInterior6 = `${baseAssetUrl}/images/gallery/images/residences-interior/06.jpg`;
const residencesInterior7 = `${baseAssetUrl}/images/gallery/images/residences-interior/07.jpg`;

const residencesCommonArea1 = `${baseAssetUrl}/images/gallery/images/residences-common-area/01.jpg`;
const residencesCommonArea2 = `${baseAssetUrl}/images/gallery/images/residences-common-area/02.jpg`;
const residencesCommonArea3 = `${baseAssetUrl}/images/gallery/images/residences-common-area/03.jpg`;

const residencesLifestyle1 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/01.jpg`;
const residencesLifestyle2 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/02.jpg`;

const destinationLifestyle1 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/01.jpg`;
const destinationLifestyle2 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/02.jpg`;
const destinationLifestyle3 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/03.jpg`;
const destinationLifestyle4 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/04.jpg`;
const destinationLifestyle5 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/05.jpg`;
const destinationLifestyle6 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/06.jpg`;
const destinationLifestyle7 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/07.jpg`;
const destinationLifestyle8 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/08.jpg`;

const video = {
  en: `${baseAssetVideoUrl}/skypark.mp4`,
  ru: `${baseAssetVideoUrl}/skypark.mp4`,
  cn: `${baseAssetVideoUrl}/skypark.mp4`,
};

const videos = [
  {
    titleKey: "propertyVideo",
    source: {
      en: `${baseAssetVideoUrl}/SkyPark_animation_3Lingual_Mar 2022.mp4`,
      cn: `${baseAssetVideoUrl}/SkyPark_animation_3Lingual_Mar 2022.mp4`,
      ru: `${baseAssetVideoUrl}/SkyPark_animation_3Lingual_Mar 2022.mp4`,
    },
    text: {
      en: ["PROPERTY VIDEO"],
      cn: ["项目视频"],
      ru: ["ВИДЕО ПРОЕКТА"],
    },
  },
  {
    titleKey: "interiorVideoStudio",
    source: {
      en: `${baseAssetVideoUrl}/SKYPARK_Studio_Interior_video_V.3_17062020.mp4`,
      cn: `${baseAssetVideoUrl}/SKYPARK_Studio_Interior_video_V.3_17062020.mp4`,
      ru: `${baseAssetVideoUrl}/SKYPARK_Studio_Interior_video_V.3_17062020.mp4`,
    },
    text: {
      en: ["STUDIO"],
      cn: ["一室公寓"],
      ru: ["СТУДИЯ"],
    },
  },
  {
    titleKey: "interiorVideoOneBedroom",
    source: {
      en: `${baseAssetVideoUrl}/SKYPARK_1-bedroom_Interior_video_V.4_17062020.mp4`,
      cn: `${baseAssetVideoUrl}/SKYPARK_1-bedroom_Interior_video_V.4_17062020.mp4`,
      ru: `${baseAssetVideoUrl}/SKYPARK_1-bedroom_Interior_video_V.4_17062020.mp4`,
    },
    text: {
      en: ["ONE - BEDROOM"],
      cn: ["一卧开间"],
      ru: ["КВАРТИРА С", "ОДНОЙ СПАЛЬНЕЙ"],
    },
  },
  {
    titleKey: "interiorVideoTwoBedroom",
    source: {
      en: `${baseAssetVideoUrl}/SKYPARK_2-bedroom_Interior_video_V.3_17062020.mp4`,
      cn: `${baseAssetVideoUrl}/SKYPARK_2-bedroom_Interior_video_V.3_17062020.mp4`,
      ru: `${baseAssetVideoUrl}/SKYPARK_2-bedroom_Interior_video_V.3_17062020.mp4`,
    },
    text: {
      en: ["TWO - BEDROOM"],
      cn: ["两卧室套房"],
      ru: ["КВАРТИРА С", "ДВУМЯ СПАЛЬНЯМИ"],
    },
  },
];

const heroShot = [
  { image: heroShotImg1 },
  { image: heroShotImg2 },
  { image: heroShotImg3 },
  { image: heroShotImg4 },
  { image: heroShotImg5 },
  { image: heroShotImg6 },
  { image: heroShotImg7 },
  { image: heroShotImg8 },
  { image: heroShotImg9 },
  // { image: heroShotImg10 },
];

const categories = [
  {
    id: 1,
    name: "All Images",
  },
  {
    id: 2,
    name: "Residences – Aerial",
  },
  {
    id: 3,
    name: "Residences – Exterior",
  },
  {
    id: 4,
    name: "Residences – Interior",
  },
  {
    id: 5,
    name: "Residences – Common Area",
  },
  {
    id: 6,
    name: "Residences – Lifestyle",
  },
  {
    id: 7,
    name: "Destination Lifestyle",
  },
];

const images = [
  {
    categoryId: 2,
    name: "Aerial - 1",
    image: residencesAerial1,
  },
  {
    categoryId: 2,
    name: "Aerial - 2",
    image: residencesAerial2,
  },
  {
    categoryId: 2,
    name: "Aerial - 3",
    image: residencesAerial3,
  },
  {
    categoryId: 2,
    name: "Aerial - 4",
    image: residencesAerial4,
  },
  {
    categoryId: 3,
    name: "Exterior - 1",
    image: residencesExterior1,
  },
  {
    categoryId: 3,
    name: "Exterior - 2",
    image: residencesExterior2,
  },
  {
    categoryId: 3,
    name: "Exterior - 3",
    image: residencesExterior3,
  },
  {
    categoryId: 3,
    name: "Exterior - 4",
    image: residencesExterior4,
  },
  {
    categoryId: 4,
    name: "One bedroom - 1",
    image: residencesInterior1,
  },
  {
    categoryId: 4,
    name: "One bedroom - 2",
    image: residencesInterior2,
  },
  {
    categoryId: 4,
    name: "Studio - 1",
    image: residencesInterior3,
  },
  {
    categoryId: 4,
    name: "Two bedroom - 1",
    image: residencesInterior4,
  },
  {
    categoryId: 4,
    name: "Two bedroom - 2",
    image: residencesInterior5,
  },
  {
    categoryId: 4,
    name: "Two bedroom - 3",
    image: residencesInterior6,
  },
  {
    categoryId: 4,
    name: "Two bedroom - 4",
    image: residencesInterior7,
  },
  {
    categoryId: 5,
    name: "Rooftop pool",
    image: residencesCommonArea1,
  },
  {
    categoryId: 5,
    name: "Sky running track",
    image: residencesCommonArea2,
  },
  {
    categoryId: 5,
    name: "Common area",
    image: residencesCommonArea3,
  },
  {
    categoryId: 6,
    name: "Lifestyle - 1",
    image: residencesLifestyle1,
  },
  {
    categoryId: 6,
    name: "Lifestyle - 2",
    image: residencesLifestyle2,
  },

  {
    categoryId: 7,
    name: "Lifestyle - 1",
    image: destinationLifestyle1,
  },
  {
    categoryId: 7,
    name: "Lifestyle - 2",
    image: destinationLifestyle2,
  },
  {
    categoryId: 7,
    name: "Lifestyle - 3",
    image: destinationLifestyle3,
  },
  {
    categoryId: 7,
    name: "Lifestyle - 4",
    image: destinationLifestyle4,
  },
  {
    categoryId: 7,
    name: "Lifestyle - 5",
    image: destinationLifestyle5,
  },
  {
    categoryId: 7,
    name: "Lifestyle - 6",
    image: destinationLifestyle6,
  },
  {
    categoryId: 7,
    name: "Lifestyle - 7",
    image: destinationLifestyle7,
  },
  {
    categoryId: 7,
    name: "Lifestyle - 8",
    image: destinationLifestyle8,
  },
];

const image360 = null;
const view360 = [
  {
    id: "AERIAL",
    src: `${baseAssetUrl}/360/aerial/SKP-Aerial.html`,
  },
  {
    id: "INTERIOR",
    type: "list",
    src: `${baseAssetUrl}/360/interior/SKP-2AL.html`,
    list: [
      {
        id: "TYPE 2A-1",
        target: "_blank",
        src: (
          <iframe
            width="100%"
            height="100%"
            src="https://my.matterport.com/show/?m=V7SYTo7mChH"
            frameborder="0"
            allowfullscreen
            allow="vr"
          ></iframe>
        ),
        href: "https://my.matterport.com/show/?m=V7SYTo7mChH",
      },
      {
        id: "TYPE 1B",
        target: "_blank",
        src: (
          <iframe
            width="100%"
            height="100%"
            src="https://my.matterport.com/show/?m=eUq9Wp3t6LD"
            frameborder="0"
            allowfullscreen
            allow="vr"
          ></iframe>
        ),
        href: "https://my.matterport.com/show/?m=eUq9Wp3t6LD",
      },
      {
        id: "TYPE 1A",
        target: "_blank",
        src: (
          <iframe
            width="100%"
            height="100%"
            src="https://my.matterport.com/show/?m=F3tM8isRq4s"
            frameborder="0"
            allowfullscreen
            allow="vr"
          ></iframe>
        ),
        href: "https://my.matterport.com/show/?m=F3tM8isRq4s",
      },
    ],
  },
];

export default {
  heroShot,
  categories,
  images: _.map(images, (image) => {
    return {
      ...image,
      category: _.find(categories, { id: image.categoryId }),
    };
  }),
  video,
  videos,
  image360,
  view360,
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/gallery.js